module.exports = __webpack_public_path__ + "static/media/team-rocket-5.65227150.wav";